import React, { useState, useEffect } from "react";
import { Route } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LeftSidebar from "../../component/admin/LeftSidebar";
import TopHeader from "../../component/admin/TopHeader";
import Modal from "./DeleteConfirmModalPopup";
import Pagination from "react-js-pagination";

const getAllNewsEvents = (data) => {
  return scAxiosAdmin
    .request("/newsevents/getallnewsevents?show_hidden=1", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem(API_TOKEN_NAME)}`,
      },
      params: data,
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const getSearchNewsEvents = (data) => {
  return scAxiosAdmin
    .request("/newsevents/adminsearchnewsevents", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem(API_TOKEN_NAME)}`,
      },
      params: data,
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const deletenewsevent = (data) => {
  return scAxiosAdmin
    .request(`/newsevents/delete/${data.newsevent_id}`, {
      method: "delete",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem(API_TOKEN_NAME)}`,
      },
      params: data,
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err;
    });
};

const NewsEvents = () => {
  const [newsevents, setNewsEvents] = useState([]);
  const [paginationData, setPaginationData] = useState({
    total: 0,
    currentPage: 1,
    perPage: 0,
    totalPages: 0,
  });
  // console.log("your log output", paginationData);
  const [searchKeywords, setSearchKeywords] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [enableShdo, setEnableShdo] = useState(false);
  const [modalDeleteConfirm, setModalDeleteConfirm] = useState(false);
  const [newseventId, setNewsEventId] = useState("");
  // console.log("your log output", activePage);
  useEffect(() => {
    refreshNewsEvents(activePage);
  }, [activePage]);

  const refreshNewsEvents = (page = 1) => {
    setEnableShdo(true);
    getAllNewsEvents({ page })
      .then((res) => {
        if (res.status) {
          setNewsEvents(res.data.data);

          setPaginationData({
            total: res.data.total,
            currentPage: res.data.current_page,
            perPage: res.data.per_page,
            totalPages: Math.ceil(res.data.total / res.data.per_page),
          });
        } else {
          setNewsEvents([]);
        }
      })
      .finally(() => setEnableShdo(false))
      .catch((err) => console.error(err));
  };

  const handleSearch = () => {
    getSearchNewsEvents({ keywords: searchKeywords })
      .then((res) => {
        if (res.status) {
          setNewsEvents(res.data.data);
          setPaginationData({
            total: res.data.total,
            currentPage: res.data.current_page,
            perPage: res.data.per_page,
            totalPages: Math.ceil(res.data.total / res.data.per_page),
          });
        } else {
          setNewsEvents([]);
        }
      })
      .catch((err) => console.error(err));
  };

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleDeleteNewsEvent = (id) => {
    deletenewsevent({ newsevent_id: id })
      .then((res) => {
        if (res.status) {
          toast.success(res.message, { position: toast.POSITION.TOP_RIGHT });
          refreshNewsEvents(activePage);
        } else {
          toast.error(res.message, { position: toast.POSITION.BOTTOM_RIGHT });
        }
      })
      .catch((err) => console.error(err));
    setModalDeleteConfirm(false);
  };
  const togglePackageStatus = async (item) => {
    const newStatus = item.status === "1" ? "0" : "1";
    const data = {
      status: newStatus,
    };

    try {
      const response = await scAxiosAdmin.post(
        `/newsevents/updatestatusnewsevents/${item.id}`,
        data
      );
      if (response.status === 200) {
        toast.success("Status updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setNewsEvents((prev) =>
          prev.map((pkg) =>
            pkg.id === item.id ? { ...pkg, status: newStatus } : pkg
          )
        );
      } else {
        toast.error("Failed to update status", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    } catch (error) {
      console.error("Error updating status:", error);
      toast.error("Failed to update status", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  const renderNewsEvents = () => {
    return newsevents.map((newsevent) => (
      <div className="col-lg-4" key={newsevent.id}>
        <div className="news-part-event">
          <img
            src={`${IMAGE_URL}/NewsEventsImg/${newsevent.news_events_pic}`}
            alt=""
            width="100%"
          />
          <div className="newdata position-relative">
            <div className="row">
              <div className="col-lg-10">
                <h3
                  className="d-inline"
                  style={{ fontSize: "18px" }}
                  title={newsevent.news_events_title}
                >
                  {newsevent.news_events_title
                    ? `${newsevent.news_events_title.substr(0, 50)}...`
                    : ""}
                </h3>
              </div>
            </div>
            <h5 className="float-end position-absolute mt-2 top-0 end-0">
              <a href={`/editnewsevent/${newsevent.id}`}>
                <i className="fa fa-pencil-square mx-2 display-4"></i>
              </a>
              <a
                className="ms-2"
                title="Status"
                onClick={() => togglePackageStatus(newsevent)}
              >
                {newsevent.status === "1" ? (
                  <i class="fa-solid fa-eye"></i>
                ) : (
                  <i class="fa-solid fa-eye-slash"></i>
                )}
              </a>
              <a href={`/viewnewsevent/${newsevent.id}`}>
                <i class="fa-solid fa-laptop mx-3"></i>
              </a>
              <a
                onClick={() =>
                  setModalDeleteConfirm(true) && setNewsEventId(newsevent.id)
                }
              >
                <i className="fa fa-trash"></i>
              </a>
            </h5>
          </div>
          <p
            dangerouslySetInnerHTML={{
              __html: newsevent.news_events_desc
                ? newsevent.news_events_desc.substr(0, 170)
                : "",
            }}
          ></p>
        </div>
      </div>
    ));
  };

  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="row page-content-wrapper">
              <div className="col-sm-7"></div>
              <div className="col-sm-3 text-right">
                <input
                  type="text"
                  className="form-control"
                  name="search_keywords"
                  value={searchKeywords}
                  onChange={(e) => setSearchKeywords(e.target.value)}
                  onBlur={handleSearch}
                  placeholder="Search"
                />
              </div>
              <div className="col-sm-2 mb-4 text-right">
                <a
                  href="/addnewsevent"
                  className="btn btn-sm btn-primary waves-effect waves-light"
                >
                  Add News Event
                </a>
              </div>
              <div className="col-lg-12">
                <div className="card m-b-20">
                  <div className="card-body">
                    <section className="view-page">
                      <div className="container">
                        <div className="view-page-box">
                          <hr />
                          <div className="row">
                            {newsevents.length > 0 ? (
                              renderNewsEvents()
                            ) : (
                              <div
                                colspan="6"
                                className="font_12 txt_col fontweight400 text-center"
                              >
                                There are currently no News Events.
                              </div>
                            )}
                          </div>
                          <br />
                        </div>
                        {paginationData.totalPages > 1 && (
                          <Pagination
                            activePage={activePage}
                            totalItemsCount={paginationData.total}
                            pageRangeDisplayed={5}
                            onChange={handlePageChange}
                          />
                        )}
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
      {modalDeleteConfirm && (
        <Modal
          show={modalDeleteConfirm}
          handleClose={() => setModalDeleteConfirm(false)}
        >
          <div className="custom_reviews_popup">
            <h2 className="text-center">
              Are you sure you want to delete this news event?
            </h2>
            <div className="form-group row">
              <div className="col-sm-3 text-center"></div>
              <div className="col-sm-6 text-center">
                <button
                  className="blue_btn_box add_staff_btn mt-5 mr-2"
                  onClick={() => setModalDeleteConfirm(false)}
                >
                  No
                </button>
                <button
                  className="blue_btn_box add_staff_btn mt-5"
                  onClick={() => handleDeleteNewsEvent(newseventId)}
                >
                  Yes
                </button>
              </div>
              <div className="col-sm-3 text-center"></div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default NewsEvents;



// WEBPACK FOOTER //
// ./src/component/admin/newsevents.js